import React, {FC} from "react"

import theme from "@irati/ui/src/global/theme"
import {H2, Body} from "@irati/ui/src/Typography"
import Flex from "@irati/ui/src/Flex"
import {FormattedMessage} from "@irati/utils/lang"

const Intro: FC = () => (
  <Flex direction="column" marginBottom={3}>
    <H2>
      <FormattedMessage id="wallet.reward.admin.intro.topup.title" />
    </H2>
    <Body marginTop={2} color={theme.colors.greys.dark}>
      <FormattedMessage id="wallet.reward.admin.intro.topup.subtitle" />
    </Body>
  </Flex>
)

export default Intro
